import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default function AddAbout() {

  const [updateAbout, setupdateAbout] = useState({})

  const homeData = async()=>{
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    fetch("https://api.padampura.com/AboutUs", requestOptions)
     .then((response) => response.json())
      .then((result) => {
        if(result.status === true){
          setupdateAbout(result.data)
        }
      })
      .catch((error) => console.error(error));
  }

  const handleChangeUpdtAbt = (e) => {
    const { name, value, type, checked } = e.target;
    setupdateAbout({
      ...updateAbout,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  
  const insertAbout = ()=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "About_ID": 1,
      ...updateAbout
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://api.padampura.com/About_Us_InsertUpdate", requestOptions)
    .then((response) => response.json())
      .then((result) => {
        if(result.status === true){
          // console.log(result)
          alert('update detail successfully')
        }else{
          alert("error")
        }
      })
      .catch((error) => console.error(error));
  }
  
    useEffect(()=>{
      homeData()
  },[])
  
  return (
    <div>
        <div className='container-fluid p-0'>
           <div className='row g-0'>
             <div className='col-2 side'>
                <Sidebar />
             </div>
             <div className='col-10 side2'>
                <Header />
               <div className='scroll-box'>
                 <div className='container-fluid'>
                    <div className='row mt-3'>
                      <div className='col-2 ms-auto'>
                         <div onClick={insertAbout} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Save</div>
                      </div>
                    </div>
                    <hr />
                    <div className='row mt-3'>
                      <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>About Brief</div>
                          {/* <textarea className='sercc-inpt p-1' name='About_Brief' rows="8"  value={updateAbout.About_Brief} onChange={handleChangeUpdtAbt} placeholder="About Brief" autoFocus required style={{width:"100%"}} /> */}
                          <CKEditor
                            editor={ClassicEditor}
                            data={updateAbout.About_Brief || ''}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setupdateAbout({
                                ...updateAbout,
                                About_Brief: data
                              });
                            }}
                            config={{
                              enterMode: 'paragraph',
                              shiftEnterMode: 'br',
                              toolbar: {
                                  items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                              },
                              heading: {
                                options: [
                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                ]
                            }
                          }}
                          />
                      </div>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Origin Of Statue</div>
                          <CKEditor
                            editor={ClassicEditor}
                            data={updateAbout.OriginOfStatue || ''}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setupdateAbout({
                                ...updateAbout,
                                OriginOfStatue: data
                              });
                            }}
                            config={{
                              enterMode: 'paragraph',
                              shiftEnterMode: 'br',
                              toolbar: {
                                  items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                              },
                              heading: {
                                options: [
                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                ]
                            }
                          }}
                          />
                      </div>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-lg-12 col-md-12 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Short About Summary</div>
                          <CKEditor
                            editor={ClassicEditor}
                            data={updateAbout.ShortAboutSummary || ''}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setupdateAbout({
                                ...updateAbout,
                                ShortAboutSummary: data
                              });
                            }}
                            config={{
                              enterMode: 'paragraph',
                              shiftEnterMode: 'br',
                              toolbar: {
                                  items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                              },
                              heading: {
                                options: [
                                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                ]
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className='row mt-3 mb-4'>
                      <div className='col-lg-3 col-md-6 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Opening Timings</div>
                          <input className='sercc-inpt p-1' name='MandirOpeningTimings' value={updateAbout?.MandirOpeningTimings} onChange={handleChangeUpdtAbt} type="time" style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-2 col-md-6 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Closing Timings</div>
                          <input className='sercc-inpt p-1' name='MandirClosingTimings' value={updateAbout.MandirClosingTimings} onChange={handleChangeUpdtAbt} type="time" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-2 col-md-6 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Abhishek Timings</div>
                          <input className='sercc-inpt p-1' name='MandirAbhishekTimings' value={updateAbout.MandirAbhishekTimings} onChange={handleChangeUpdtAbt} type="time" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-2 col-md-6 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Aarti Timings</div>
                          <input className='sercc-inpt p-1' name='MandirAartiTimings' value={updateAbout.MandirAartiTimings} onChange={handleChangeUpdtAbt} type="time" autofocus required style={{width:"100%"}} />
                      </div>
                      <div className='col-lg-3 col-md-6 col-sm-12'>
                        <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>ShantiDhara Timings</div>
                          <input className='sercc-inpt p-1' name='MandirShantiDharaTimings' value={updateAbout.MandirShantiDharaTimings} onChange={handleChangeUpdtAbt} type="time" autofocus required style={{width:"100%"}} />
                      </div>
                    </div>
                 </div>
               </div>
             </div>
           </div>
        </div>
    </div>
  )
}
